<template>
  <b-container>
    <b-form v-on:submit.prevent>
      <b-row>
        <b-col cols="8">
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Details</label
            >
            <b-row>
              <b-col cols="6">
                <b-form-group label="Organization" label-for="organization">
                  <v-select
                    id="organization"
                    v-model="form.selectedOrganization"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsOrganization"
                    placeholder="Select 1 Organization"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedOrganization"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedOrganization }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Location" label-for="location">
                  <v-select
                    id="location"
                    v-model="form.selectedLocation"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsLocation"
                    placeholder="Select 1 Location"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedLocation"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedLocation }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Code" label-for="code">
                  <b-form-input
                    id="code"
                    placeholder="Code"
                    v-model="form.code"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Category" label-for="category">
                  <v-select
                    id="category"
                    v-model="form.selectedCategory"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsCategory"
                    placeholder="Select 1 Category"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedCategory"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedCategory }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                ><b-form-group label="Name" label-for="name">
                  <b-form-input
                    id="name"
                    placeholder="Name"
                    v-model="form.name"
                    required
                  /> </b-form-group
              ></b-col>
            </b-row>
            <b-row>
              <b-col cols="6"
                ><b-form-group label="Qty" label-for="qty">
                  <b-form-input
                    id="qty"
                    type="number"
                    placeholder="Qty"
                    v-model="form.qty"
                    required
                  /> </b-form-group
              ></b-col>
              <b-col cols="6"
                ><b-form-group label="Price" label-for="price">
                  <cleave
                    id="price"
                    placeholder="Price"
                    v-model="form.price"
                    class="form-control"
                    :raw="false"
                    :options="options.number"
                    required
                  /> </b-form-group
              ></b-col>
            </b-row>
            <b-row>
              <b-col cols="6"
                ><b-form-group label="Purchase Date" label-for="purchase_at">
                  <flat-pickr
                    id="purchase_at"
                    v-model="form.purchase_at"
                    class="form-control"
                    placeholder="Select Date"
                    :required="form.purchase_at === null ? true : false"
                  >
                  </flat-pickr>
                  <!-- :config="{ dateFormat: 'd-m-Y'}" -->
                  <!-- Selected: <strong>{{ form.purchase_at }}</strong> -->
                </b-form-group></b-col
              >
              <b-col cols="6"
                ><b-form-group label="Use Date" label-for="use_at">
                  <flat-pickr
                    id="use_at"
                    v-model="form.use_at"
                    class="form-control"
                    placeholder="Select Date"
                    required
                  />
                  <!-- :config="{ dateFormat: 'd-m-Y'}" -->
                  <!-- Selected: <strong>{{ form.use_at }}</strong> -->
                </b-form-group></b-col
              >
            </b-row>
            <b-row>
              <b-col cols="6"
                ><b-form-group label="Lifetime" label-for="lifetime">
                  <b-input-group append="Years">
                    <b-form-input
                      id="lifetime"
                      type="number"
                      placeholder="Lifetime"
                      v-model="form.lifetime"
                      required
                    />
                  </b-input-group> </b-form-group
              ></b-col>
              <b-col cols="6"
                ><b-form-group label="Decrease Type" label-for="decrease_type">
                  <v-select
                    id="decrease_type"
                    v-model="form.selectedDecreaseType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsDecreaseType"
                    placeholder="Select 1 Decrease Type"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedDecreaseType"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedLocation }}</strong> -->
                </b-form-group></b-col
              >
            </b-row>
            <b-row>
              <!-- submit and reset -->
              <b-col
                class="mt-2"
                v-if="permissions.includes('asset-item-update')"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  @click="validation()"
                  block
                >
                  Update
                </b-button>
              </b-col>
              <b-col
                class="mt-2"
                v-if="permissions.includes('asset-item-update')"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="danger"
                  class="mr-1"
                  @click="deleteAssetItem()"
                  block
                >
                  Delete
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card
            ><b-form-group
              :state="errors"
              label="Photo"
              label-for="Photo"
              invalid-feedback="Photo is required"
            >
              <validation-provider
                #default="{ errors }"
                name="Photo"
                rules="required"
              >
                <b-img
                  id="photoURL"
                  :src="photo"
                  fluid
                  alt="asset item photo"
                  class="mb-1"
                  v-if="(hasImage === '') | null"
                />
                <image-uploader
                  id="file"
                  :preview="true"
                  :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                  :debug="0"
                  :autoRotate="true"
                  accept="image/*"
                  doNotResize="['gif', 'svg']"
                  outputFormat="string"
                  @input="setImage"
                ></image-uploader>
                <small class="text-danger">{{
                  errors[0] || errMessageImage
                }}</small>
              </validation-provider>
            </b-form-group></b-card
          >
          <b-card v-if="logs.length > 0">
            <app-timeline>
              <label for="logs" class="mb-2 text-primary font-weight-bold h6"
                >History</label
              >
              <app-timeline-item
                v-for="(log, index) in logs"
                :key="index"
                :title="log.description"
                subtitle=""
                :time="moment(log.created_at)"
                :variant="log.variant"
              />
            </app-timeline>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTextarea,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Cleave from "vue-cleave-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import moment from "moment";

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    ImageUploader,
    Cleave,
    flatPickr,
    ToastificationContent,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BImg,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        code: "",
        name: "",
        selectedCategory: null,
        optionsCategory: [],
        selectedOrganization: null,
        optionsOrganization: [],
        selectedLocation: null,
        optionsLocation: [],
        purchase_at: null,
        use_at: null,
        qty: null,
        price: null,
        lifetime: null,
        selectedDecreaseType: null,
        optionsDecreaseType: [
          { value: 1, text: "Straight Line" },
          { value: 2, text: "Declining Balance" },
          { value: 3, text: "Sum of Years" },
        ],
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      permissions: [],
      logs: [],
      hasImage: "",
      image: "",
      photo: "",
      errors: "",
      errMessage: "",
      errMessageImage: "",
    };
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
    this.getCategories();
    this.getOrganization();
    this.getLocation();
    this.getLogs();
  },
  methods: {
    moment(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    setImage: function (file) {
      this.hasImage = true;
      this.image = file;
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("asset/item/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.code = response.data.data.code;
        this.form.name = response.data.data.name;
        this.form.selectedCategory = {
          value: response.data.data.category_id,
          text: response.data.data.category_name,
        };
        this.form.selectedOrganization = {
          value: response.data.data.organization_id,
          text: response.data.data.organization_name,
        };
        this.form.selectedLocation = {
          value: response.data.data.location_id,
          text: response.data.data.location_name,
        };
        this.form.qty = response.data.data.qty;
        this.form.price = response.data.data.price;
        this.form.lifetime = response.data.data.lifetime;
        this.form.selectedDecreaseType = {
          value: response.data.data.decrease_type,
          text: response.data.data.decrease_type_name,
        };
        this.form.purchase_at = response.data.data.purchase_at;
        this.form.use_at = response.data.data.use_at;
        const { baseUrl } = $themeConfig.app;
        this.photo = baseUrl;
        this.photo += "storage/asset_item/";
        this.photo += response.data.data.image;
        this.image = this.getBase64Image(document.getElementById("photoURL"));
      });
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      this.image = canvas.toDataURL("image/png");
      this.image += this.image.replace(/^data:image\/(png|jpg);base64,/, "");
      // console.log(this.image)
    },
    getCategories() {
      this.$http.get("asset/categories/all").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          // console.log(datas[1].children.length === 0)
          if (datas[i].children.length === 0) {
            var $data = {
              value: datas[i].id,
              text: datas[i].name,
            };
            // console.log($data)
            this.form.optionsCategory.push($data);
          } else {
            // var $dataParent = {
            //     value: datas[i].id,
            //     text: datas[i].name,
            //     disabled: true
            // }
            // this.form.optionsCategory.push($dataParent)

            var j;
            var datas2 = datas[i].children;
            // console.log(datas2[i].name)
            for (j = 0; j < datas2.length; j++) {
              var $dataChildren = {
                value: datas2[j].id,
                text: datas[i].name + " - " + datas2[j].name,
              };
              this.form.optionsCategory.push($dataChildren);
            }
          }
        }
      });
    },
    getOrganization() {
      this.$http.get("organizations/all").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          // console.log(datas[1].children.length === 0)
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsOrganization.push($data);
        }
        // console.log(this.form.optionsOrganization)
      });
    },
    getLocation() {
      this.$http.get("asset/locations").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          // console.log(datas[1].children.length === 0)
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsLocation.push($data);
        }
        // console.log(this.form.optionsLocation)
      });
    },
    getLogs() {
      const id = this.$route.params.id;
      this.$http.get("asset/item/" + id + "/logs").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            description: datas[i].description,
            created_at: datas[i].created_at,
            variant: "secondary",
          };
          this.logs.push($data);
        }
      });
    },
    validation() {
      if (this.form.code === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Code field is required",
            variant: "warning",
          },
        });
      } else if (this.form.name === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Name field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedCategory === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Category field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedOrganization === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Organization field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedLocation === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Location field is required",
            variant: "warning",
          },
        });
      } else if (this.form.qty === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Qty field is required",
            variant: "warning",
          },
        });
      } else if (this.form.price === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Price field is required",
            variant: "warning",
          },
        });
      } else if (this.form.lifetime === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Lifetime field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedDecreaseType === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Decrease Type field is required",
            variant: "warning",
          },
        });
      } else if (this.form.purchase_at === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Purchase Date field is required",
            variant: "warning",
          },
        });
      } else if (this.form.use_at === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Use Date field is required",
            variant: "warning",
          },
        });
      } else if (this.image === "" && this.photo === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Image field is required",
            variant: "warning",
          },
        });
      } else {
        this.updateAssetItem();
      }
    },
    updateAssetItem() {
      const id = this.$route.params.id;
      var newPrice = this.form.price;
      newPrice = newPrice.replace(/\,/g, "");
      this.$http
        .post("asset/item/" + id + "/update", {
          code: this.form.code,
          name: this.form.name,
          category_id: this.form.selectedCategory.value,
          organization_id: this.form.selectedOrganization.value,
          location_id: this.form.selectedLocation.value,
          qty: this.form.qty,
          price: newPrice,
          lifetime: this.form.lifetime,
          decrease_type: this.form.selectedDecreaseType.value,
          purchase_at: this.form.purchase_at,
          use_at: this.form.use_at,
          image: this.image,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add Asset Item",
              variant: "success",
            },
          });
          location.href = "/asset/asset-item";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    deleteAssetItem() {
      const id = this.$route.params.id;
      this.$http
        .post("asset/item/" + id + "/delete")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Asset Item has been Deleted",
              variant: "danger",
            },
          });
          location.href = "/asset/asset-item";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style>
img.img-preview {
  width: 100%;
  margin-bottom: 15px;
}
</style>